import type { DrawMode, Epoch } from '@life/engine';
import type { Speed } from './clock';

/** Настройки игрока; живут в сохранении вместе с жизнью. */
export interface Settings {
  epoch: Epoch;
  drawMode: DrawMode;
  /** Желаемая длительность сессии в реальных минутах. */
  durationMin: 30 | 60 | 90;
  /** Заменять тяжёлые записи нейтральными (делает движок). */
  skipHeavy: boolean;
  /** ISO3 реальной страны игрока для сравнения; null — не указана. */
  realCountry: string | null;
  theme: 'system' | 'light' | 'dark';
  music: boolean;
  hintsSeen: boolean;
  /** Скорость часов ×1…×16; живёт между перезагрузками. */
  speed: Speed;
  /** Раздел E (азартные мини-игры) включён; учебный режим (план 6) ставит false. */
  gamblingEnabled: boolean;
  /** Ход года (core-loop-v2): `turn` — год идёт по кнопке «Следующий год»; `observe` — часы реального времени. */
  mode: GameMode;
}

export type GameMode = 'turn' | 'observe';
export const GAME_MODES: readonly GameMode[] = ['turn', 'observe'];

export const DEFAULT_SETTINGS: Settings = {
  epoch: 'present',
  drawMode: 'births',
  durationMin: 60,
  skipHeavy: false,
  realCountry: null,
  theme: 'system',
  music: false,
  hintsSeen: false,
  speed: 1,
  gamblingEnabled: true,
  mode: 'turn',
};
